export const studyConst = {
    SESSION_DEFAULT_SECONDS: 1800,
};
